module.exports = __webpack_public_path__ + "static/product_cloud-bf1fee25ae0a9665d92e1c97afb91bdc.png";